module.exports = __webpack_public_path__ + "static/img/btn4.caf02ff6.png";